import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
//import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
//import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
import { initParams } from './reducers/params';
import { initData } from './reducers/data';
import App from './components/App/App';
import './index.css';
import i18n from './i18n';

let isFP = false
// the id of the div to render too
let appId = `${process.env.REACT_APP_APP_ID}` ? `${process.env.REACT_APP_APP_ID}` : 'myportfolios'
let windowAppId = `${process.env.REACT_APP_WINDOW_APP_ID}` ? `${process.env.REACT_APP_WINDOW_APP_ID}` : 'portfolioMapper'


// optionally load attributes from script tag
function getSyncScriptParams() {
  const scripts = document.getElementsByTagName('script')
  const lastScript = scripts[scripts.length - 1]
  const scriptName = lastScript
  // override from attributes if they exist
  if (scriptName.getAttribute('appId')) {
    appId = scriptName.getAttribute('appId')
  }
  if (scriptName.getAttribute('mode')) {
    isFP = scriptName.getAttribute('mode') === 'fp' ? true : false
  }

  initParams.wtRegion = `${window[windowAppId].wtRegion}` && `${window[windowAppId].wtRegion}` !== 'undefined' ? `${window[windowAppId].wtRegion}` : 'US'
  initParams.entityCCY = `${window[windowAppId].entityCCY}` && `${window[windowAppId].entityCCY}` !== 'undefined' ? `${window[windowAppId].entityCCY}` : 'USD'
  initParams.tenant = `${window[windowAppId].tenant}` && `${window[windowAppId].tenant}` !== 'undefined' ? `${window[windowAppId].tenant}` : 'wisdomtree'

  const normalizedClientEmail = `${window[windowAppId].clientEmail}`.toLowerCase()
  initParams.clientEmail = normalizedClientEmail && normalizedClientEmail !== 'undefined' && normalizedClientEmail !== 'null'
    ? `${window[windowAppId].clientEmail}`
    : 'unknown@unknown.com'

  initParams.pdfReportConfigId = `${window[windowAppId].pdfReportConfigId}` && `${window[windowAppId].pdfReportConfigId}` !== 'undefined' ? `${window[windowAppId].pdfReportConfigId}` : ''
  initParams.dataspanApiUrl = `${process.env.REACT_APP_API_URL}`

  const normalizedToken = `${window[windowAppId].token}`.toLowerCase()
  initParams.token = normalizedToken && normalizedToken !== 'undefined' && normalizedToken !== 'null'
    ? `${window[windowAppId].token}`
    : ''

  initParams.version = `${process.env.REACT_APP_VERSION}` !== 'undefined' ? `${process.env.REACT_APP_VERSION}` : 'DEV'
  initParams.isFP = window.isFP ? true : isFP
  initParams.isoCode = `${window[windowAppId].isoCode}` && `${window[windowAppId].isoCode}` !== 'undefined' ? `${window[windowAppId].isoCode}` : 'en-US'

  let personalStrategiesPdfConfigId = ''
  let personalStrategiesIncomePdfId = ''
  let personalStrategiesGrowthPdfId = ''

  if (window.myportfolios) {
    if (window.myportfolios.personalStrategiesPdfConfigId) {
      personalStrategiesPdfConfigId = window.myportfolios.personalStrategiesPdfConfigId
    }
    if (window.myportfolios.personalStrategiesIncomePdfId) {
      personalStrategiesIncomePdfId = window.myportfolios.personalStrategiesIncomePdfId
    }  
    if (window.myportfolios.personalStrategiesGrowthPdfId) {
      personalStrategiesGrowthPdfId = window.myportfolios.personalStrategiesGrowthPdfId
    }        
  }

  initParams.pdfReportConfigId = personalStrategiesPdfConfigId
  initParams.personalStrategiesIncomePdfId = personalStrategiesIncomePdfId
  initParams.personalStrategiesGrowthPdfId = personalStrategiesGrowthPdfId


  // Change the language to that specified in the page.
  i18n.changeLanguage(initParams.isoCode)

}
getSyncScriptParams()

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false,
  }),
  preloadedState: { params: initParams, data: initData },
});



const root = document.getElementById(appId);

createRoot(root).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
